import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import { useTranslation } from "react-i18next";
import {
    POLL_TYPE,
    TEXTBOX,
    USER_SETTINGS,
    BUTTON,
    DEFAULT_COUNT_DOWN_TIME_LIMIT,
} from "../../utils/constants";
import YuJaButton from "../standardization/YuJaButton";
import "./modal.css";
import classes from "../../pages/PPTPlugin/PPTPollsPage.module.css";
import settingsClasses from "../../pages/PlatformSetting/Settings.module.css";
import {deCapitalizeWord, } from "../../utils/helpers";

import TimeLimitInput from "../TimeLimitInput";
import YuJaSwitch from "../standardization/YuJaSwitch";


export default function PollTimeLimitModal({show, setShow, pollData, handleShareAll, handleOpen, userSettings}) {
    const { t } = useTranslation();
    const {poll={}, } = pollData;

    const { pollType} = poll;


    const [isSubmitting, setIsSubmitting] = useState(false);
    const [pollTimeLimit, setPollTimeLimit] = useState(
        pollType === POLL_TYPE.ATTENDANCE
            ? poll.attendanceDuration
            : poll.pollTimeLimit
    );
    const [isUnlimitedTime, setIsUnlimitedTime] = useState(poll.manualEnd === "true" || poll.manualEnd === true);
    const [pollCountDown, setPollCountDown] = useState(
        pollType !== POLL_TYPE.ATTENDANCE
            ? (!!poll.getReadyAllTimeLimit ? poll.getReadyAllTimeLimit : userSettings[USER_SETTINGS.POLL_COUNTDOWN])
            : 0
    );


    const handleSubmit = async () => {
        let timeLimit = isUnlimitedTime ? 0 : pollTimeLimit;

        setIsSubmitting(true);
        try {
            if (pollType === POLL_TYPE.ATTENDANCE) {
                await handleOpen(timeLimit);
            } else { // shareAll
                await handleShareAll(timeLimit, pollCountDown);
            }
            setShow(false);
        } finally {
            setIsSubmitting(false);
        }

    };

    return (
        <Modal
            show={show}
            dialogClassName="activity-options-modal"
            onHide={() =>  setShow(false)}
        >
            <Modal.Header
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <ModalClose
                    tabIndex={0}
                    role={BUTTON}
                    onClick={() => setShow(false)}
                    className="modal-close"
                    aria-label={t("common.close")}
                />
                <Modal.Title
                    className="modal-title"
                    id="contained-modal-title-vcenter"
                    role={TEXTBOX}
                >
                    {pollType === POLL_TYPE.ATTENDANCE ? t("questionBuilder.releaseAttendanceButton") : t("questionBuilder.releasePollButton")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={classes.column} style={{gap: 15}}>
                    <div className={classes.description}>
                        {t("poll.releaseActivityOptionsDescription", {activityType: pollType === POLL_TYPE.ATTENDANCE ? deCapitalizeWord(t("attendance.label")) : deCapitalizeWord(t("poll.mergedModeText"))})}
                    </div>
                    {pollType === POLL_TYPE.MERGED_POLL &&
                        <>
                            <div className={classes.row} style={{gap: 15}}>
                                <div className={classes.column}>
                                    <div className={settingsClasses.settingLabel}>{t("gradebook.pollLengthSettingText")}</div>
                                    <div className={settingsClasses.settingDescription}>{t("gradebook.pollLengthSettingDesc")}</div>
                                </div>
                                <div style={{flex: 1}}/>
                                <YuJaSwitch
                                    aria-label={t("gradebook.pollLengthSettingText")}
                                    checked={isUnlimitedTime}
                                    onChange={checked => {
                                        if (!!checked) {
                                            setPollTimeLimit(0);
                                        } else {
                                            setPollTimeLimit(!!poll.pollTimeLimit ? poll.pollTimeLimit : userSettings[USER_SETTINGS.POLL_DURATION]);
                                        }
                                        setIsUnlimitedTime(checked);
                                    }}
                                />
                            </div>


                            {!isUnlimitedTime &&
                                <div className={classes.row} style={{gap: 20, alignItems: "end", marginTop: 15}}>
                                    <div className={classes.column} style={{flex: 1, minWidth: 0}}>
                                        <div className={settingsClasses.settingLabel}>{t("questionBuilder.pollTimeLimitText")}</div>
                                        <span className={settingsClasses.settingDescription}>
                                                {t("poll.participantTimeIntro", {activityType: pollType === POLL_TYPE.ATTENDANCE ? deCapitalizeWord(t("attendance.label")) : deCapitalizeWord(t("poll.mergedModeText"))})}
                                            </span>
                                    </div>
                                    <TimeLimitInput
                                        timeLimit={pollTimeLimit}
                                        setTimeLimit={(timeLimit) => {
                                            setPollTimeLimit(timeLimit);
                                            if (!timeLimit) {
                                                setIsUnlimitedTime(true);
                                            }
                                        }}
                                        unit={"HH:MM"}
                                    />
                                </div>
                            }

                            <div className={classes.row} style={{marginTop: 20, gap: 20}}>
                                <div className={classes.column} style={{maxWidth: 500}}>
                                    <div className={settingsClasses.settingLabel}>{t("questionBuilder.countdownTimerLabel")}</div>
                                    <div className={settingsClasses.settingDescription}>
                                        {t("questionBuilder.pollCountdownTimerDescription")}
                                    </div>
                                </div>
                                <div style={{flex: 1, minWidth: 0}}/>
                                <TimeLimitInput
                                    timeLimit={pollCountDown}
                                    setTimeLimit={(timeLimit) => {
                                        setPollCountDown(timeLimit);
                                    }}
                                    unit={"MM:SS"}
                                    minVal={DEFAULT_COUNT_DOWN_TIME_LIMIT}
                                    reachMinValErrorText={t("settings.minimumCountdownError")}
                                />
                            </div>

                        </>
                    }
                    {pollType === POLL_TYPE.ATTENDANCE &&
                        <>
                            <div className={classes.row} style={{gap: 15}}>
                                <div className={classes.column}>
                                    <div className={settingsClasses.settingLabel}>{t("gradebook.attendanceLengthSettingText")}</div>
                                    <div
                                        className={settingsClasses.settingDescription}>{t("gradebook.attendanceLengthSettingDesc")}</div>
                                </div>
                                <div style={{flex: 1}}/>
                                <YuJaSwitch
                                    aria-label={t("gradebook.attendanceLengthSettingText")}
                                    checked={isUnlimitedTime}
                                    onChange={checked => {
                                        if (!!checked) {
                                            setPollTimeLimit(0);
                                        } else {
                                            setPollTimeLimit(
                                                !!poll.attendanceDuration
                                                    ? poll.attendanceDuration
                                                    : userSettings[USER_SETTINGS.ATTENDANCE_DURATION]
                                            );
                                        }
                                        setIsUnlimitedTime(checked);
                                    }}
                                />
                            </div>
                            {!isUnlimitedTime &&
                                <div className={classes.row} style={{gap: 20, alignItems: "end", marginTop: 15}}>
                                    <div className={classes.column} style={{flex: 1, minWidth: 0}}>
                                        <div className={settingsClasses.settingLabel}>{t("questionBuilder.attendanceTimeLimitText")}</div>
                                        <span className={settingsClasses.settingDescription}>
                                            {t("poll.participantTimeIntro", {activityType: pollType === POLL_TYPE.ATTENDANCE ? deCapitalizeWord(t("attendance.label")) : deCapitalizeWord(t("poll.mergedModeText"))})}
                                        </span>
                                    </div>
                                    <TimeLimitInput
                                        timeLimit={pollTimeLimit}
                                        setTimeLimit={(timeLimit) => {
                                            setPollTimeLimit(timeLimit);
                                            if (!timeLimit) {
                                                setIsUnlimitedTime(true);
                                            }
                                        }}
                                        unit={"HH:MM"}
                                    />
                                </div>
                            }
                        </>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <YuJaButton type="secondary" onClick={() => setShow(false)}>{t("common.cancel")}</YuJaButton>
                <YuJaButton disabled={isSubmitting} onClick={handleSubmit}>{t("navigation.releasePrefix").trim()}</YuJaButton>
            </Modal.Footer>
        </Modal>
    );
}